import {createType, createAction} from 'store/utils';

const prefix = 'MONEY_BOX';

export const UPDATE_MONEY_BOX = createType(prefix, 'UPDATE');
export const updateMoneyBox = (payload: MoneyBoxState): Action =>
  createAction(UPDATE_MONEY_BOX, payload);
